<template>
  <div
    class="app-bar"
    :style="styles"
  >
    <slot name="icon" />

    <div class="d-flex align-items-center justify-content-between w-100 h-100">
      <slot name="left" />
      <slot name="center" />
      <slot name="right" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'VAppBar',
  props: {
    height: {
      type: String,
      default: '60',
    },
  },
  computed: {
    styles() {
      return {
        height: `${this.height}px`,
      };
    },
  },
};
</script>

<style lang="scss">
@import "VAppBar";
</style>
